import { render, staticRenderFns } from "./makeWish.vue?vue&type=template&id=4dea208a&scoped=true"
import script from "./makeWish.vue?vue&type=script&lang=ts"
export * from "./makeWish.vue?vue&type=script&lang=ts"
import style0 from "./makeWish.vue?vue&type=style&index=0&id=4dea208a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea208a",
  null
  
)

export default component.exports